<div class="confirm-dialog" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <h3>{{ text }}</h3>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="100">
      <mat-form-field fxFlex="100">
        <mat-label>Powód</mat-label>
        <input [required]="true" matInput placeholder="Powód" [formControl]="reasonControl">
        <mat-error *ngIf="reasonControl.hasError('required')">Musisz podać powód</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row" *ngIf="registrationObject?.insuranceCompany?.cession || ofwcaObject" fxLayoutGap="15px">
    <div fxFlex="100">
      <mat-slide-toggle color="accent" [formControl]="cessionControl"> Cesja</mat-slide-toggle>
    </div>
  </div>

  <div fxLayout="column" *ngIf="cessionControl.value">

    <div fxLayout="row" fxLayoutGap="15px"  *ngFor="let cancelRegistrationForm of cancelRegistrationForms">
      <div style="  height: 100%; display: flex; justify-content: flex-end;flex-direction: column;" fxFlex="50">
        <div style=" padding-top: 0; padding-bottom: 20px;">
          <div style="color: #777; font-size: 13px;">
            Z rejestracji
          </div>
          <div style="color: black; font-size: 16px; margin-top: 10px; min-height: 16px; hyphens: auto; word-break: break-word;  border-bottom: 1px #e2e2e2 dashed;">
            {{ cancelRegistrationForm.currentRegistration.insuranceCompany.name }} Firma: {{cancelRegistrationForm.currentRegistration.contract.company.name }}
          </div>
        </div>
      </div>
        <app-dict-registrations
          label="Na rejestracje" fxFlex="50"
          [required]="!ofwcaObject"
          [control]="cancelRegistrationForm.newRegistrationControl"
          [filterInsuranceCompany]="cancelRegistrationForm.currentRegistration.insuranceCompany"
          [status]="true" [filterStatus]="[REGISTRATION_STATUS_REGISTERED]"
          [company]="true"
          [cession]="true"
        ></app-dict-registrations>
     </div>
  </div>

  <mat-error *ngIf="newRegistrationsArray.hasError('backendError')">
    {{ newRegistrationsArray.getError('backendError') }}
  </mat-error>

  <div fxLayout="row" fxLayoutGap="15px">

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !cancelRegistrationFormValid"
    >Zapisz</button>
  </div>
</div>
